import { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { Instagram, ArrowUp } from 'lucide-react';

function Clock({ timezone, city }) {
  const [time, setTime] = useState('');
  useEffect(() => {
    const update = () => setTime(new Date().toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit', second: '2-digit', hour12: false, timeZone: timezone }));
    update();
    const id = setInterval(update, 1000);
    return () => clearInterval(id);
  }, [timezone]);
  return (
    <div>
      <p className="text-[10px] font-mono uppercase tracking-widest text-neutral-400 mb-0.5">{city}</p>
      <p className="text-sm font-mono text-neutral-600">{time}</p>
    </div>
  );
}

export default function Footer() {
  const scrollTop = () => window.scrollTo({ top: 0, behavior: 'smooth' });

  return (
    <footer className="bg-[#121212] overflow-hidden">
      {/* Giant typographic name */}
      <div className="px-6 lg:px-12 pt-16 pb-0 overflow-hidden">
        <motion.h2
          initial={{ opacity: 0, y: 60 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 1, ease: [0.16, 1, 0.3, 1] }}
          className="font-serif font-light text-[#FDFCF7]/10 leading-none select-none"
          style={{ fontSize: 'clamp(4rem, 14vw, 14rem)', letterSpacing: '-0.02em' }}
        >
          ELENA VANCE
        </motion.h2>
      </div>

      {/* Footer content */}
      <div className="max-w-7xl mx-auto px-6 lg:px-12 py-12 border-t border-white/[0.06]">
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-8 mb-12">
          {/* Brand */}
          <div>
            <p className="font-serif text-xl font-light text-[#FDFCF7] mb-1">Elena Vance</p>
            <p className="text-xs font-mono text-neutral-500 tracking-wide">Editorial & Architectural</p>
            <p className="text-xs font-mono text-neutral-500">Photography · Est. 2015</p>
          </div>

          {/* Clocks */}
          <div className="flex gap-8">
            <Clock timezone="Europe/Paris" city="Paris" />
            <Clock timezone="Asia/Tokyo" city="Tokyo" />
          </div>

          {/* Social + Back to top */}
          <div className="flex flex-col items-start sm:items-end gap-4">
            <a
              href="https://instagram.com"
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center gap-2 text-xs font-mono uppercase tracking-widest text-neutral-400 hover:text-[#FDFCF7] transition-colors duration-300"
            >
              <Instagram size={14} strokeWidth={1.25} />
              @elenavance
            </a>
            <button
              onClick={scrollTop}
              className="flex items-center gap-2 text-xs font-mono uppercase tracking-widest text-neutral-400 hover:text-[#FDFCF7] transition-colors duration-300 group"
            >
              <ArrowUp size={14} strokeWidth={1.25} className="group-hover:-translate-y-0.5 transition-transform duration-300" />
              Back to top
            </button>
          </div>
        </div>

        <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-3 border-t border-white/[0.06] pt-6">
          <p className="text-[11px] font-mono text-neutral-600">
            © {new Date().getFullYear()} Elena Vance. All rights reserved.
          </p>
          <p className="text-[11px] font-mono text-neutral-600">
            Paris · Tokyo · The world
          </p>
        </div>
      </div>
    </footer>
  );
}
